export class Config {
  static adminApiBaseUrl = '/api';
  static contentApiBaseUrl = '/content-api';
}
